import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";

import { firebase } from "../../../../configs/firebase.config.js";
import { auth } from "../../../../configs/firebase.config.js";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/material/styles";
import MuiCard from "@mui/material/Card";
import axios from "axios";
import config from "../../../../configs/config.js";

const Card = styled(MuiCard)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: { width: 450 },
}));

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [completingSignIn, setCompletingSignIn] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        navigate("/content/txn");
      }
    });

    // Handle the email link redirect
    if (auth.isSignInWithEmailLink(window.location.href)) {
      const storedEmail = window.localStorage.getItem("emailForSignIn");
      if (storedEmail) {
        completeSignIn(storedEmail);
      } else {
        setLoginError("Please re-enter your email to complete sign-in.");
      }
    }

    return () => unsubscribe();
  }, [navigate]);

  const completeSignIn = async (emailToUse) => {
    setCompletingSignIn(true);
    setLoginError("");
    try {
      const result = await auth.signInWithEmailLink(emailToUse, window.location.href);
      window.localStorage.removeItem("emailForSignIn");
      window.history.replaceState({}, document.title, window.location.pathname);
      console.log("Signed in successfully:", result.user);
      navigate("/content/txn");
    } catch (error) {
      console.error(error);
      setLoginError(error.message || "Failed to complete sign-in. The link may have expired.");
      setCompletingSignIn(false);
    }
  };

  const handleSendLink = async (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return alert("Please enter a valid email address");
    }

    setLoginError("");
    try {
      // Optional: keep the existing user check (update backend to accept email if needed)
      const check = await axios({
        method: "post",
        url: `${config.node_api_endpoint}/user`,
        data: { email },
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      });

      if (!check.data?.data) {
        alert("User not found!");
        return;
      }

      const actionCodeSettings = {
        url: window.location.origin + window.location.pathname,
        handleCodeInApp: true,
      };

      await auth.sendSignInLinkToEmail(email, actionCodeSettings);
      window.localStorage.setItem("emailForSignIn", email);
      setEmailSent(true);
    } catch (error) {
      console.error(error);
      setLoginError(error.message || "Failed to send sign-in link. Please try again.");
    }
  };

  const renderForm = (isMobile = false) => (
    <>
      <Box sx={{ mb: isMobile ? 1 : 5 }}>
        <Typography
          sx={{
            mb: isMobile ? 2 : 1.5,
            textAlign: "center",
            fontSize: isMobile ? "14px" : "18px",
            fontWeight: 600,
            letterSpacing: "0.18px",
          }}
        >
          Welcome to your Escrow Stack Dashboard
        </Typography>
        <Typography variant="body2" sx={{ textAlign: "center", fontSize: isMobile ? "12px" : "14px" }}>
          Please sign-in to continue
        </Typography>
      </Box>

      {completingSignIn ? (
        <Typography sx={{ textAlign: "center", my: 4 }}>Completing sign-in...</Typography>
      ) : (
        <form noValidate autoComplete="off" onSubmit={handleSendLink}>
          <TextField
            className="input-box"
            autoFocus
            fullWidth
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
            label="Enter your email address"
            sx={{ mb: isMobile ? 3 : 5 }}
          />

          <Button
            type="submit"
            fullWidth
            size="large"
            variant="contained"
            disabled={emailSent}
            sx={{
              "&:hover": { backgroundColor: "#3151aa" },
              mb: isMobile ? 4 : 4,
              backgroundColor: "#2447a9",
              borderRadius: "12px",
            }}
          >
            {emailSent ? "Link Sent" : "Send Sign-in Link"}
          </Button>

          {emailSent && (
            <Typography className="email-sent-message">
              A sign-in link has been sent to <strong>{email}</strong>.<br />
              Please check your inbox (and spam folder) and click the link to log in.
            </Typography>
          )}

          {loginError && (
            <Typography className="login-error">{loginError}</Typography>
          )}
        </form>
      )}
    </>
  );

  return (
    <div className="login-div">
      <div className="container-login"></div>

      {window.innerWidth > 600 && (
        <div className="input-box-div">
          <Box className="content-center" sx={{ flex: 0.3, marginTop: 8 }}>
            <Card className="container-login-input-card" sx={{ borderRadius: "20px" }}>
              <div className="content-input">
                <CardContent sx={{ p: (theme) => `${theme.spacing(9, 7, 6.5)} !important` }}>
                  <Box sx={{ mb: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img src="/escrow-stack.svg" style={{ width: 160, height: 80 }} alt="logo" />
                  </Box>
                  {renderForm(false)}
                </CardContent>
              </div>
            </Card>
          </Box>
        </div>
      )}

      {window.innerWidth <= 600 && (
        <div className="input-box-div2">
          <Box className="content-center" sx={{ flex: 0.3, marginTop: 35, padding: "0 16px 0 16px" }}>
            <Card className="container-login-input-card" sx={{ borderRadius: "20px" }}>
              <div className="content-input">
                <CardContent sx={{ p: (theme) => `${theme.spacing(6, 4, 5.5)} !important` }}>
                  <Box sx={{ mb: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img src="/escrow-stack.svg" style={{ width: 120, height: 60 }} alt="logo" />
                  </Box>
                  {renderForm(true)}
                </CardContent>
              </div>
            </Card>
          </Box>
        </div>
      )}
    </div>
  );
};

export default Login;